import { useState, useEffect } from 'react';
import shopify from "@src/../js/shopify";

function useCartData() {
    const [cart, setCart] = useState(null);

    // Function to fetch the product details
    const fetchProducts = async (productIds) => {
        const products = await shopify.getShopifyProductList(productIds);
        return products;
    };

    // Function to fetch and enrich the cart data
    const fetchCart = async () => {
        let cartDataResponse = null;

        window.dispatchEvent(
            new CustomEvent('show-spinner', {
                detail: { id: 'cart-spinner' },
            })
        );

        try {
            const response = await fetch(`/cart.js`);
            cartDataResponse = await response.json();

            if (cartDataResponse) {
                const productIdsList = [
                    ...new Set(cartDataResponse.items.map((item) => item.product_id)),
                ];

                const products = await fetchProducts(productIdsList);

                const updatedItems = cartDataResponse.items.map((item) => {
                    const product = products.find((p) => item.product_id === p.id);
                    return product
                        ? { ...item, product }
                        : item;
                });

                const enrichedCart = {
                    ...cartDataResponse,
                    items: updatedItems,
                };
                setCart(enrichedCart);
                window.dispatchEvent(
                    new CustomEvent('cart-fetched', {
                        detail: { cart: enrichedCart },
                    })
                );
            }
        } catch (error) {
            console.error('Error fetching cart:', error);
        } finally {

            window.dispatchEvent(
                new CustomEvent('hide-spinner', {
                    detail: { id: 'cart-spinner' },
                })
            );
        }
    };

    useEffect(() => {
        // Initial cart fetch
        fetchCart();

        // Listen for cart updates
        document.addEventListener('liquid-ajax-cart:request-end', fetchCart);

        return () => {
            document.removeEventListener('liquid-ajax-cart:request-end', fetchCart);
        };
    }, []);

    return {
        cart,
        fetchCart
    };
}

export default useCartData;
